export const SITE = {
  name: "N S Physiotherapy",
  tagline: "Finding Paths to Relief",
  phone: "050 215 7368",
  phoneRaw: "0502157368",
  phoneIntl: "27502157368",
  whatsappNumber: "064 873 3990",
  whatsappRaw: "0648733990",
  whatsappIntl: "27648733990",
  email: "info@nsphysiotherapy.co.za",
  whatsapp: "https://wa.me/27648733990?text=Hello%2C%20can%20I%20speak%20to%20the%20physio",
  facebook: "https://www.facebook.com/605667692627058",
  instagram: "https://www.instagram.com/nsphysiotherapy",
  addressCenturion: "Shop 11, Highveld, Eco Boulevard Shopping Centre, 270 Witch Hazel Avenue, Centurion, 0157, South Africa",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/services", label: "Services" },
  { to: "/physio-at-home", label: "Physio@Home" },
  { to: "/back-and-neck-assessment", label: "Back & Neck Check" },
  { to: "/testimonials", label: "Reviews" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
  { to: "/booking", label: "Booking" },
];
